import feathersClient, { makeServicePlugin, BaseModel } from '@/api-client'

class Order extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'Order'

  static instanceDefaults (data, { store, models }) {
    return {
      status: 'SUBMITTED'
    }
  }
}
const servicePath = 'orders'
const servicePlugin = makeServicePlugin({
  Model: Order,
  // IMPORTANT
  whitelist: ['$eager', '$iRegexp', '$regex', '$options'],
  service: feathersClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
